import React from 'react';
import {
  DialogContainer,
  DialogHeader,
  DialogTitle,
  DialogText,
  DialogFooter,
} from '../shared';

interface InterviewInterruptedDialogProps {
  open: boolean;
}

const InterruptedIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
    <g clipPath="url(#clip0_195_4186)">
      <path d="M18 31.5C25.4558 31.5 31.5 25.4558 31.5 18C31.5 10.5442 25.4558 4.5 18 4.5C10.5442 4.5 4.5 10.5442 4.5 18C4.5 25.4558 10.5442 31.5 18 31.5Z" fill="#F59E0B" stroke="#F59E0B" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M22.5 13.5L13.5 22.5" stroke="white" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M13.5 13.5L22.5 22.5" stroke="white" strokeWidth="2.25" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_195_4186">
        <rect width="36" height="36" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

const InterviewInterruptedDialog: React.FC<InterviewInterruptedDialogProps> = ({
  open,
}) => {
  return (
    <DialogContainer open={open}>
      <DialogHeader variant="interview" icon={<InterruptedIcon />} />

      <div style={{ padding: '24px', textAlign: 'center', borderTop: '1px solid #F59E0B' }}>
        <DialogTitle color="#B45309" size="lg" centered>
          Interview Ended!
        </DialogTitle>
        <DialogText centered style={{ marginBottom: 0 }}>
          Your interview session ended before all questions were completed.
          <br />
          All responses submitted up to this point have been sent for evaluation.
        </DialogText>
      </div>

      <DialogFooter />
    </DialogContainer>
  );
};

export default InterviewInterruptedDialog;
